<template>

    <div class="col-md-12">
        <div class="h2 mb-3">Create Agreement</div>
        <form @submit.prevent="addAgreement">
            <div class="p-4 mb-3 bg-white rounded-lg">
                <div class="container-fluid bg-light py-3">
                    <div class="form-group">
                        <label>
                            <b> {{ JSON.parse(client).name }} </b>
                            <span class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                  :class="agreement.name==='' && isSubmit? 'border-danger':''">
                                       <input type="text" class="form-control  border-0 py-0 shadow-none form-input"
                                              autocomplete="none" placeholder="Agreement name" name="whatever"
                                              v-model="agreement.name"/>
                            </span>
                        </label>
                    </div>

                </div>
            </div>

            <div class="p-4 mb-0 bg-white rounded-lg">
                <div class="h4 mb-3"> General information</div>
                <div class="">

                    <div class="container-fluid bg-light py-3">
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-3">
                                    <strong> Name: </strong> <br/> <br/>
                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="agreement.name==='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Agreement name"
                                                   v-model="agreement.name">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                </div>

                                <div class="col-sm-4">
                                    <strong> Default pickup address: </strong> <br/> <br/>
                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="agreement.pickupAddressName==='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Name"
                                                   v-model="agreement.pickupAddressName">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="agreement.pickupAddressStreet==='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Address"
                                                   v-model="agreement.pickupAddressStreet">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="agreement.pickupAddressZip==='' && isSubmit? 'border-danger':''">
                                                    <input type="text" autocomplete="none" required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="Zip code"
                                                           v-model="agreement.pickupAddressZip" ref="pickupAddressZip">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="agreement.pickupAddressCity==='' && isSubmit? 'border-danger':''">
                                                    <input type="text" autocomplete="none" required
                                                           class="form-control  border-0 py-0 shadow-none form-input"
                                                           placeholder="City"
                                                           v-model="agreement.pickupAddressCity"
                                                           ref="dropoffAddressCity">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="agreement.pickupAddressCountryId==='' && isSubmit? 'border-danger':''">
                                            <select required class="form-control border-0 py-0 shadow-none pr-5">
                                                <option value="1" :selected=true>Denmark</option>
                                            </select>
                                        </div>
                                    </div>
                                    ..or choose from existing: <br/>
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="agreement.existingPickupAddresses==='' && isSubmit? 'border-danger':''">
                                        <select @change="onChangePickupAddress($event)"
                                                class="form-control border-0 py-0 shadow-none pr-5"
                                                v-model="agreement.existingPickupAddresses">
                                            <option v-for="item in JSON.parse(client).addresses"
                                                    v-if="item.type === 1"
                                                    v-bind:value="item.id">
                                                {{ item.name }} {{ item.street }}, {{ item.zip }} {{ item.city }},
                                                {{ item.country_id }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <strong> Default dropoff address: </strong> <br/> <br/>
                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="agreement.dropoffAddressName==='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Name"
                                                   v-model="agreement.dropoffAddressName" ref="dropoffAddressName">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="agreement.dropoffAddressStreet==='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Address"
                                                   v-model="agreement.dropoffAddressStreet"
                                                   ref="dropoffAddressStreet">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="agreement.dropoffAddressZip==='' && isSubmit? 'border-danger':''">
                                                    <input type="text" autocomplete="none" required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="Zip code"
                                                           v-model="agreement.dropoffAddressZip"
                                                           ref="dropoffAddressZip">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="agreement.dropoffAddressCity==='' && isSubmit? 'border-danger':''">
                                                    <input type="text" autocomplete="none" required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="City"
                                                           v-model="agreement.dropoffAddressCity"
                                                           ref="dropoffAddressCity">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="agreement.dropoffAddressCountryId==='' && isSubmit? 'border-danger':''">
                                            <select required class="form-control border-0 py-0 shadow-none pr-5">
                                                <option value="1" :selected=true>Denmark</option>
                                            </select>
                                        </div>
                                    </div>

                                    ..or choose from existing: <br/>
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="agreement.existingDropoffAddresses==='' && isSubmit? 'border-danger':''">
                                        <select @change="onChangeDropoffAddress($event)"
                                                class="form-control border-0 py-0 shadow-none pr-5"
                                                v-model="agreement.existingDropoffAddresses">
                                            <option v-for="item in JSON.parse(client).addresses"
                                                    v-if="item.type === 2 && item.deleted_at===null"
                                                    v-bind:value="item.id">
                                                {{ item.name }} {{ item.street }}, {{ item.zip }} {{ item.city }},
                                                {{ item.country_id }} {{ item.deleted_at }} -
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-1">
                                    <strong> Primary: </strong><br/>
                                    <div v-if="JSON.parse(client).addresses.length > 0">
                                        <div v-if="primaryAgreementExists===true">
                                            <label class="newInput">
                                                <input type="checkbox" disabled>
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div v-else>
                                            <label class="newInput">
                                                <input type="checkbox" v-model="agreement.primary_agreement">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span class="oi oi-check"></span>
                                        <input type="hidden" v-model="agreement.primary_agreement">
                                    </div>
                                    <br/><br/>
                                    <strong>Agreement type: </strong><br>
                                    <div class="form-group">
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <select class="form-control"
                                                    v-model="agreement.type"
                                            >
                                                <option v-for="(typeName, key) in types" :value="key">{{ typeName }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br/><br/>
                                    <strong>Label format: </strong><br>
                                    <div class="form-group">
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <select class="form-control"
                                                    v-model="agreement.label_format"
                                            >
                                                <option v-for="(name, key) in labelFormats" :value="key">
                                                    {{ name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary btn-lg" @click="validation()">Save</button>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <a href="/clients" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center mt-3">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "AgreementCreate",
    props: {
        client: {type: String, required: true},
        types: {type: Object, required: true},
        labelFormats: {type: Object, required: true},
        labelFormatPdf: {type: Number, required: true},
    },
    data() {
        return {
            address: JSON.parse(this.client).addresses,
            primaryAgreementExists: false,
            agreement: {primary_agreement: 0, label_format: this.labelFormatPdf},
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        addAgreement() {
            let uri = '/agreements';
            this.agreement.clientId = JSON.parse(this.client).id;
            axios.post(uri, this.agreement).then(() => {
                window.location.href = `/clients/${JSON.parse(this.client).id}/edit`;
            }).catch(err => console.log(err))
        },
        onChangePickupAddress(event) {
            let addressData = this.address.filter(p => p.id == event.target.value);

            if (addressData.length > 0) {
                this.agreement.pickupAddressName = addressData[0].name;
                this.agreement.pickupAddressStreet = addressData[0].street;
                this.agreement.pickupAddressZip = addressData[0].zip;
                this.agreement.pickupAddressCity = addressData[0].city;
                this.agreement.pickupAddressCountryId = 1;
            }
        },
        onChangeDropoffAddress(event) {
            let addressData = this.address.filter(p => p.id == event.target.value);

            if (addressData.length > 0) {
                this.agreement.dropoffAddressName = addressData[0].name;
                this.agreement.dropoffAddressStreet = addressData[0].street;
                this.agreement.dropoffAddressZip = addressData[0].zip;
                this.agreement.dropoffAddressCity = addressData[0].city;
                this.agreement.dropoffAddressCountryId = 1;
            }
        },
        checkIfPrimaryAgreementExists() {
            axios.get(`/check-primary-agreement/${JSON.parse(this.client).id}`, this.agreement).then((response) => {
                this.primaryAgreementExists = response.data.result;
                if (!this.primaryAgreementExists) {
                    this.agreement.primary_agreement = 1;
                }
            }).catch(err => console.log(err))
            this.agreement.pickupAddressName=JSON.parse(this.client).name;
            this.agreement.pickupAddressStreet = JSON.parse(this.client).billing_street;
            this.agreement.pickupAddressZip = JSON.parse(this.client).billing_zip;
            this.agreement.pickupAddressCity = JSON.parse(this.client).billing_city;
            this.agreement.pickupAddressCountryId = 1;

            this.agreement.dropoffAddressName=JSON.parse(this.client).name;
            this.agreement.dropoffAddressStreet = JSON.parse(this.client).billing_street;
            this.agreement.dropoffAddressZip = JSON.parse(this.client).billing_zip;
            this.agreement.dropoffAddressCity = JSON.parse(this.client).billing_city;
            this.agreement.dropoffAddressCountryId = 1;
        }
    },
    created() {
        return this.checkIfPrimaryAgreementExists()
    },
}

</script>
